import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import Link from "gatsby-link";
import * as React from 'react';
export default {
  FontAwesomeIcon,
  faChevronCircleRight,
  Link,
  React
};